export enum UserNoticeSubSectionType {
    Open = 0,
    Closed,
    Lost,
    DeclinedByBFI,
    Repaid,
    Missing,
    All,
}
